import React, { FC } from 'react';

import { EMetric, StatsResult } from 'api/useAnalytics';

import DataTable from 'components/DataTableComponent/DataTable';
import { Card } from 'components/ui/card';

import { useColumns } from './hooks/useColumns';
import { useStatsTableData } from './hooks/useStatsTableData';

type AttributeValue = string;

interface KPISummaryTableProps {
  attributeValues: AttributeValue[];
  statsData: Record<AttributeValue, StatsResult[]>; 
  isLoading?: boolean;
  metrics: EMetric[];
}

export const KPISummaryTable: FC<KPISummaryTableProps> = ({
  attributeValues,
  statsData,
  isLoading = false,
  metrics
}) => {
  const tableData = useStatsTableData({ attributeValues, statsData, metrics });
  const columns = useColumns({ attributeValues });

  return (
    <Card className="p-[24px] shadow-none">
      <h3 className="text-lg font-semibold text-base-foreground mb-4">
        Main KPIs Summary Table
      </h3>
      <DataTable
        data={tableData}
        columns={columns}
        isLoading={isLoading}
        showPagination={false}
        size="sm"
      />
    </Card>
  );
}; 